// Downscale a large photo/screenshot before it is uploaded to the agent. Non-images
// are never passed through here. Shared by the RFA-from-screenshot modal and the
// assistant panel so both send the same thing.
const MAX_WIDTH = 1920;
const MAX_HEIGHT = 1080;

const resizeImage = (file) =>
  new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      let { width, height } = img;
      if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
        resolve(file);
        return;
      }
      const scale = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) =>
          resolve(
            new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            })
          ),
        'image/jpeg',
        0.85
      );
    };
    img.src = objectUrl;
  });

export default resizeImage;
